import { Box } from '@src/atoms/Box';
import React, { FC, useContext } from 'react';
import { Text } from '@src/atoms/Text';
import { BreakpointsContext } from '@centra/ui-global-context';
import { Portal } from '@src/core/Portal';

import styled from './ZoomFileName.module.scss';

interface IZoomFileNameBlockProps {
  fileName: string;
}

export const ZoomFileName: FC<IZoomFileNameBlockProps> = ({ fileName }) => {
  const { isMobile } = useContext(BreakpointsContext);

  if (isMobile) {
    return (
      <Portal>
        <Box fullWidth className={styled.rootMobile}>
          <Text id={'fileOriginalNameText'} align="center" color={'basicWhite'} size="secondary">
            {fileName}
          </Text>
        </Box>
      </Portal>
    );
  }

  return (
    <Box fullWidth justifyContent={'center'}>
      <Text id={'fileOriginalNameText'} color={'basicWhite'} size="secondary" align="center">
        {fileName}
      </Text>
    </Box>
  );
};
